import { CheckOutlined } from '@ant-design/icons';
import { Icon } from '@synergy/icons';
import { ComplexTable } from '@synergy/table';
import { Button, Checkbox, Divider, Form, Input, Select, Switch, Tooltip } from "antd";
import TextArea from "antd/es/input/TextArea";
import clsx from 'clsx';
import i18next from "i18next";
import React from "react";
import styled from 'styled-components';
import { MultipleSelectAtomic } from "../../components/Global/Atomics/MultipleSelectAtomic";
import Spinner from "../../components/Global/Atomics/Spinner";
import { Text } from "../../components/Global/Atomics/Text";
import { Field } from '../../styles/global/Pages.styled';
import Theme from "../../styles/Theme/Theme";

const WidgetHeader = styled.div`
display : flex;
height: 32px;
`

const TransparentPasswordInput = styled(Input.Password)`
  background-color: transparent !important;
  border: none !important;

  input {
    background-color: transparent !important;
  }
`;

export const createField = (form, entry, t, fieldStatus, setFieldStatus, handleOk, props) => {
    if (entry.fieldTypeOf === 'Label' || entry.fieldTypeOf === 'Switch' || entry.fieldTypeOf === 'Divider') {
        return getField(form, entry, t, fieldStatus, setFieldStatus, handleOk, props)
    } else {
        return (
            <Field id={entry.key} key={entry.key} $backgroundColor='neutral-1'>
                {getField(form, entry, t, fieldStatus, setFieldStatus, handleOk, props)}
            </Field>)
    }

}

const getField = (form, entry, t, fieldStatus, setFieldStatus, handleOk, props) => {
    switch (entry.fieldTypeOf) {
        case 'Label':
            return entry.name;
        case 'MultiSelect':
            if (entry?.options && entry?.value && !Array.isArray(entry?.value)) {
                entry.value = JSON.parse(entry.value).map(x => { return { label: x, value: x } });
            }
            return (
                <>
                    <WidgetHeader className="widget-header" >
                        <Text
                            $fontColor='coolgray-10'
                            $marginLeft="s03"
                            $fontSize="text_xs"
                            $weight="medium"
                            style={{ paddingTop: '8px', marginRight: entry?.description ? '2%' : null }}
                        >
                            {entry?.name}
                        </Text>
                        {addTooltip(entry)}
                    </WidgetHeader>
                    <Form.Item
                        name={entry.key}
                        rules={[{ required: entry.required, message: 'This is required.' }]}
                    >
                        <MultipleSelectAtomic
                            optionsData={entry.options}
                            placeholder={t(entry?.placeholder ?? "Select Value")}
                            initialValue={entry?.value ?? []}
                            fullWidth={true}
                            isModal={true}
                            allAvailable={true}
                            disabled={entry?.disabled}
                            loading={entry?.loading}
                        />
                    </Form.Item>
                </>
            )
        case 'SingleSelect':
        case 'TagSelect': {
            let selectMode;
            if (entry.fieldTypeOf === 'TagSelect') {
                selectMode = 'tags';
            } else if (entry?.mode === 'multiple') {
                selectMode = 'multiple';
            } else {
                selectMode = null;
            }

            return (
                <>
                    <WidgetHeader className="widget-header" >
                        <Text
                            $fontColor='coolgray-10'
                            $marginLeft="s03"
                            $fontSize="text_xs"
                            $weight="medium"
                            style={{ paddingTop: '8px', marginRight: entry?.description ? '2%' : null }}
                        >
                            {entry?.name}
                        </Text>
                        {addTooltip(entry)}
                    </WidgetHeader>
                    <Form.Item
                        name={entry.key}
                        rules={[{ required: entry.required, message: 'This is required.' }]}
                    >
                        <Select
                            showSearch={entry.showSearch ?? false}
                            filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            mode={selectMode}
                            allowClear={entry?.allowClear ?? false}
                            listHeight={200}
                            placeholder={
                                <span style={{ color: "lightgrey" }}>
                                    {entry.fieldTypeOf === 'TagSelect' ? t(entry?.placeholder ?? "Insert Values") : t(entry?.placeholder ?? "Select Value")}
                                </span>}
                            size={'large'}
                            bordered={false}
                            options={entry?.options}
                            className={clsx('select-atomic', props?.className, 'full-width')}
                            disabled={entry?.disabled}
                            loading={entry?.loading}
                            onChange={(value, option) => {
                                if (typeof entry?.onChange === 'function') {
                                    entry?.onChange(value, option)
                                }
                            }}
                        />
                    </Form.Item>
                </>
            )
        }
        case 'Number':
        case 'TextBox':
        case 'Password':
            return (
                <>
                    <WidgetHeader className="widget-header" >
                        <Text
                            $fontColor='coolgray-10'
                            $marginLeft="s03"
                            $fontSize="text_xs"
                            $weight="medium"
                            style={{ paddingTop: '8px', marginRight: entry?.description ? '2%' : null }}
                        >
                            {entry?.name}
                        </Text>
                        {addTooltip(entry)}
                    </WidgetHeader>
                    <Form.Item
                        name={entry.key}
                        validateStatus={entry?.validateRule ? fieldStatus.validateStatus : null}
                        help={entry?.validateRule ? fieldStatus.help : null}
                        validateTrigger={[
                            entry?.validateTrigger,
                            entry?.ruleValidateTrigger,
                            "onChange"
                        ]}
                        rules={[
                            ...(entry.required ? [{
                                required: true, message: 'This is required.',
                                validateTrigger: "onChange"
                            }] : []),
                            ...(entry.rule ? [{
                                pattern: entry.rule,
                                message: entry.ruleMessage ?? "Doesn't follow the expected pattern",
                                validateTrigger: entry?.ruleValidateTrigger
                            }] : []),
                            ...(entry.validateRule ? [{
                                validator: (rule, value) => entry.validateRule(rule, value, setFieldStatus)
                            }] : [])
                        ]}
                    >
                        {entry.fieldTypeOf === 'Password' ? (
                            <TransparentPasswordInput
                                disabled={entry.disabled}
                                placeholder={t(entry?.placeholder ?? "Insert Value")}
                                size="large"
                                styles={{ backgroundColor: 'transparent', border: 'none' }}
                                style={{
                                    backgroundColor: 'transparent',
                                    border: 'none'
                                }} />
                        )
                            :
                            <Input
                                disabled={entry.disabled}
                                type={entry.fieldTypeOf === 'Number' ? 'number' : 'text'}
                                placeholder={t(entry?.placeholder ?? "Insert Value")}
                                size="large"
                                style={{
                                    backgroundColor: 'transparent',
                                    border: 'none'
                                }} />
                        }

                    </Form.Item >
                </>
            )
        case 'Textarea':
            return (
                <>
                    <WidgetHeader className="widget-header" >
                        <Text
                            $fontColor='coolgray-10'
                            $marginLeft="s03"
                            $fontSize="text_xs"
                            $weight="medium"
                            style={{ paddingTop: '8px', marginRight: entry?.description ? '2%' : null }}
                        >
                            {entry?.name}
                        </Text>
                        {addTooltip(entry)}
                    </WidgetHeader>
                    <Form.Item
                        name={entry.key}
                        rules={[
                            { required: entry.required, message: 'This is required.' },
                        ]}
                    >
                        <TextArea
                            bordered={false}
                            placeholder={t("Input Text")}
                            autoSize={{ minRows: 1, maxRows: 6 }}
                            disabled={entry?.disabled}
                        />
                    </Form.Item>
                </>
            )
        case 'Checkbox':
            return (
                <>
                    {addTooltip(entry)}
                    <Form.Item
                        name={entry.key}
                        valuePropName="checked"
                        rules={[{ required: entry.required, message: 'This is required.' }]}
                    >
                        <Checkbox
                            disabled={entry?.disabled}
                        >
                            {entry.name}
                        </Checkbox>
                    </Form.Item>

                </>
            )
        case 'Button':
            return (
                entry?.btnFunction &&
                <Button type="primary" onClick={() => { entry?.btnFunction(handleOk) }} disabled={entry?.disabled}>
                    {entry?.text}
                </Button>
            )
        case 'Table':
            return (
                <>
                    {addTooltip(entry)}
                    <ComplexTable
                        fetchData={entry?.listData}
                        language={i18next.resolvedLanguage}
                        tableConfiguration={{ collumnsConfiguration: entry?.tableConfig }}
                        editButton={entry?.allowedToWrite && entry?.toEdit}
                        deleteButton={entry?.allowedToWrite && entry?.toDelete}
                        fixedActions={true}
                        handleDelete={(record) => { entry?.handleDelete(record) }}
                        pagination={{ pageSize: 5 }}
                        handleEdit={(record) => { entry?.handleEdit(record) }}
                        hasCheckbox={entry?.hasCheckbox}
                        onRowSelect={entry?.onRowSelect}
                        isLoading={entry?.isLoading}
                        cleanRowSelectedOnDataChanged={entry?.cleanRowSelectedOnDataChanged}
                    />
                </>
            )
        case 'Divider':
            return (
                <Divider>{entry?.text}</Divider>
            )
        case 'Switch':
            return (
                <>
                    {entry?.name && <WidgetHeader className="widget-header" >
                        <Text
                            $fontColor='coolgray-10'
                            $marginLeft="s03"
                            $fontSize="text_xs"
                            $weight="medium"
                            style={{ paddingTop: '8px', marginRight: entry?.description ? '2%' : null }}
                        >
                            {entry?.name}
                        </Text>
                        {addTooltip(entry)}
                    </WidgetHeader>}
                    <Form.Item
                        name={entry.key}
                        rules={[
                            { required: entry.required, message: 'This is required.' },
                        ]}
                        valuePropName="checked"
                    >
                        <Switch
                            checkedChildren={entry?.checked}
                            unCheckedChildren={entry?.unChecked}
                            onChange={e => {
                                if (entry?.switchFn) {
                                    entry?.switchFn(e)
                                }
                            }}
                            disabled={entry?.disabled}
                            defaultChecked={entry?.value?.type === CheckOutlined}
                        />
                    </Form.Item>
                </>
            )
        case 'Custom':
            return (
                <>
                    {entry?.name && <WidgetHeader className="widget-header" >
                        <Text
                            $fontColor='coolgray-10'
                            $marginLeft="s03"
                            $fontSize="text_xs"
                            $weight="medium"
                            style={{ paddingTop: '8px', marginRight: entry?.description ? '2%' : null }}
                        >
                            {entry.name}
                        </Text>
                        {addTooltip(entry)}
                    </WidgetHeader>}
                    <Form.Item
                        name={entry.key}
                        rules={[{ required: entry.required, message: 'This is required.' }]}
                    >
                        {entry.customObject(form)}
                    </Form.Item>
                </>
            )
        default:
            return (
                <div style={{ height: 'inherit', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <Spinner stroke="green" />
                </div>
            )
    }
}

const addTooltip = (entry) => {
    return entry.description && (
        <Tooltip
            className="widget-tooltip"
            title={
                <div>
                    {entry.description.split('\n').map((line, idx) => (
                        <React.Fragment key={idx}>
                            {line}
                            {idx < entry.description.split('\n').length - 1 && <br />}
                        </React.Fragment>
                    ))}
                </div>
            }
            color={Theme.color.white}
            colorText={Theme.color["coolgray-12"]}
            overlayStyle={{ zIndex: 9999 }}
        >
            <Button
                shape="circle"
                type="text"
                icon={
                    <Icon icon={"Information"} iconsize="xs" color="blue-4" />
                }
            />
        </Tooltip >)
}